export default {
  TOTAL_WITHDRAWAL_REPOSITORY: Symbol.for('TOTAL_WITHDRAWAL_REPOSITORY'),
  CREATE_TOTAL_WITHDRAWAL_COMMAND: Symbol.for('CREATE_TOTAL_WITHDRAWAL_COMMAND'),
};
